import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
    button: {
      display: "block",
      margin: theme.spacing(12, 0, 16, "auto"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    dragDropText: {
      color: theme.gray400,
      fontSize: 13,
      opacity: "0.8",
    },
    fullWidth: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
  }),
);
